import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    standalone: false
})
export class ToggleSwitchComponent {
  @Input({ required: true }) label: string;
  @Input({ required: true }) checked: boolean;
  @Input({ required: false }) disabled: boolean;

  @Output() triggered = new EventEmitter<boolean>();

  toggleSwitch(): void {
    this.triggered.emit(this.checked);
  }
}
